// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import chapterGoalEntity from './entities/chapter-goal.json';
import chapterGoalMenu from '../pages/chapter-goal/menu.json';
import chapterGoalFullForm from '../pages/chapter-goal/forms/full.json';
import chapterGoalContextForm from '../pages/chapter-goal/forms/context.json';
import chapterGoalMiniForm from '../pages/chapter-goal/forms/mini.json';
import chapterGoalLookupForm from '../pages/chapter-goal/forms/lookup.json';
import chapterGoalTableView from '../pages/chapter-goal/views/table.json';
import chapterGoalCardsView from '../pages/chapter-goal/views/cards.json';
import chapterGoalDashboardView from '../pages/chapter-goal/views/dashboard.json';

/** Тип запису «Ціль розділу» зі сторінками пакета: меню, форми та подання з pages/chapter-goal/. */
export const chapterGoalDefinition: IRecordTypeDefinition = {
  ...chapterGoalEntity,
  views: assembleViewSet({
      table: chapterGoalTableView,
      cards: chapterGoalCardsView,
      dashboard: chapterGoalDashboardView,
  }),
  form: chapterGoalFullForm,
  forms: { full: chapterGoalFullForm, context: chapterGoalContextForm, mini: chapterGoalMiniForm, lookup: chapterGoalLookupForm },
  menu: chapterGoalMenu,
} as IRecordTypeDefinition;
